<script >
	import Nav from "../../components/WebSite/Nav.svelte";
	import Footer from "../../components/WebSite/Footer.svelte";
	import { productImg } from '../../stores.js';


	export let id = null;

	let splitId =[];

 	let countryName = null;
	let productKey = null;
	let productObj = null;
	let partners = null;

	let fluxogramPath = '/img/';
	
	

	$:{
		if(id != null){
			
			splitId = id.split('_');
			countryName = splitId[0];
			fluxogramPath = fluxogramPath + countryName + '/'; 
			productKey = 'img'+splitId[1];
			productObj	= productImg[countryName][productKey];
			partners = productImg[countryName]['partners'].url;
			console.log('partners:', partners);
			fluxogramPath = fluxogramPath + productObj.fluxogram;
			console.log('productObj:', productObj);

		}
		
	}

	function openFluxogram(){

		window.open(fluxogramPath,'__blank');

	}


	function goBackToMap(){

		window.location.href = "/";
		localStorage.setItem('scrollId','#ourProductsContainer');
	}

</script>

<Nav changeNavElement={true}/>
<main>
	
	<div class="infoContainer" id="infoContainer">

		<div class="imgContainer" style="background-image: url({productObj.cover});">
			<i class="fa-solid fa-caret-left arrow" on:click={goBackToMap}>Back to map</i>
		</div>

		<div class="descriptionContainer">

			<div class="productName">
					{productObj.name}	
			</div>

			<div class="productDescription">
				{productObj.description}
			</div>

			<div class="partnerContainer">

				{#each partners as partner }
					<!-- <div class="partner-logo"> -->
						<img class="partner-logo" src={partner} alt="partner logo" />	
					<!-- </div>	 -->
				{/each}
				
				
			</div>
		</div>
	</div>

	<div class="textContainer">
		<div class="text">
			DO YOU KNOW HOW IT’S MADE?
		</div>
		<div  class="text">
			Check the process <a class="textClick" on:click={openFluxogram}>here</a>
		</div>
			
	</div>


	<Footer/>
</main>





<style>

:root{
	--brand: #FFAE6A;		
}



@media only screen and (min-width: 768px) {

	main {
		width:100%;
		height:100%;
		background-color: white;
		display: block;
		overflow: scroll;
		overflow-x: hidden;
		scrollbar-width: none;
		position: relative;
	
	}

	main::-webkit-scrollbar {
	    width: 0em;
	}

	.infoContainer{
		width:100vw;
		height:70vh;
		background-image: url('/img/orangeBack.png');
		background-repeat: no-repeat;
		background-size: cover;
		display: flex;
		flex-direction: row;
		color: black;
		margin-top: 3%;


	}

	.textContainer{
		width:100vw;
		height:30vh;
		background-color: white;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: flex-start;


		

	}

	.text{
		color: #333333;
		font-style: normal;
		font-weight: 700;
		font-size: 1.9vw;
		text-transform: none;
		font-family: 'Roboto', sans-serif;
		text-align: justify;
		text-align-last: center;
		letter-spacing: 0.03em;
		line-height: 155%;
	}

	.text:nth-child(1){
		margin-top: 3%;
	}

	.textClick{
		color: #EF9144;
		font-style: normal;
		font-weight: 700;
		font-size: 1.9vw;
		text-transform: none;
		text-align: justify;
		text-align-last: center;
		letter-spacing: 0.03em;
		line-height: 155%;
	}
	.textClick:hover{
		opacity: 0.8;
	}


	.fluxogram{
		width: 40%;
		margin: auto;
		margin-top: 5%;
	}

	.imgContainer{

		width: 100%;
		height: auto;
		background-size:cover;
		background-position: center center;
		background-repeat: no-repeat;
		display: flex;
		align-items: flex-start;
		justify-content: flex-start;

	}
	.arrow{
		font-style: normal;
		font-weight: 900;
		font-size: 1vw;
		margin-top: 3%;
		margin-left: 1%;
		opacity: 0.8;
		cursor: pointer;
	}

	.arrow:hover{
		opacity: 1;
	}
	

	.productImg{
		width: 100%;
		height:100%;
		background-color: transparent;
		display: flex;
		align-items: center;
		justify-content: center;
		background-color: darkcyan;
		/*background-image: url('/img/roundTriangle.png');
		background-repeat: no-repeat;
		background-size: contain;
*/
	}

	.item{
		display: flex;
		align-items: center;
		justify-content: center;
		max-width: 55%;
		max-height: 55%;
	}



	.descriptionContainer{
		width: 60%;
		height: 96%;
		display: flex;
		align-self: flex-end;
		align-items: center;
		justify-content: flex-start;
		flex-direction: column;
	}

	.productName{
		width:  90%;
		height: 20%;
		display: flex;
		align-items: center;
		justify-content: center;
		color: #333333;
		font-style: normal;
		font-weight: 700;
		font-size: 4vh;
		display: flex;
		align-items: flex-start;
		justify-content: flex-start;
		text-transform: none;
		text-align: justify;
		text-align-last: center;
		letter-spacing: 0.03em;
		/*transform: translateY(28%);*/
	}

	.productDescription{
		width: 90%;
		height: 55%;
		color: #333333;
		font-style: normal;
		font-weight: 700;
		font-size: 1.5vw;
		display: flex;
		align-items: center;
		justify-content: flex-start;
		text-transform: none;
		/*font-family: 'Bebas Neue';*/
		/*font-family: 'Roboto', sans-serif;*/
		/*background-color: blue;*/
		text-align: justify;
		text-align-last: center;
		letter-spacing: 0.03em;
		line-height: 155%;
	}

	.partnerContainer{
		width: 90%;
		height: 25%;
		display: flex;
		align-items: flex-start;
		justify-content: flex-end;
	}

	.partner-logo{
		width: auto;
		height: 90%;
		background-size: contain;
		background-repeat: no-repeat;
		background-position: center center;

	}

}		
</style>